import View from '../../../Core/View.js';
import Swiper from 'swiper';

class PhotoSlider extends View {

	initialize() {
		this.swiper = new Swiper(this.$el.find('.photo-slider__photos'), {
			grabCursor: true,
			autoplay: 4000,
			spaceBetween: 0,
			allowSwipeToPrev: false,
			allowSwipeToNext: false,
			autoplayDisableOnInteraction: false,
			pagination: {
				el: this.$el.find('.photo-slider__pagination').get(0),
				type: 'bullets',
				clickable: true,
			},
		});
	}
}

export default PhotoSlider;


// WEBPACK FOOTER //
// ./js/Views/Modules/PhotoSlider/PhotoSlider.js